"use strict";
//
// インポート
//
import { gsap, Power3, Power0 } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { EaselPlugin } from "gsap/EaselPlugin";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin(EaselPlugin, ScrollTrigger, ScrollToPlugin);
import { CssCustomProperties } from "./utility/_cssCustomProperties";
import { SmoothScroll } from "./utility/_smoothScroll";
import { initAccordions } from "./utility/_accordion";
import { initProgressBar } from "./utility/_progress";
import { initSpanWrap } from "./utility/_spanWrap";
import { initScrollAnimation } from "./utility/_scrollAnimation";
import { Drawer } from "./utility/_drawer";

//
// 変数宣言
//

const mediaQuery = window.matchMedia("screen and (min-width: 960px)");
const header = document.querySelector(".header");
const headerLogo = document.querySelector(".header-logo");
const footer = document.querySelector(".footer");
const pageTop = document.querySelector(".footer-go-top");
const fixedBanner = document.querySelector(".common-fixed");
//
// イベントリスナー
//

window.addEventListener("DOMContentLoaded", () => {
  new CssCustomProperties();
  new SmoothScroll();
  initDrawer();
  const accordions = document.querySelectorAll(".js-accordion");
  initAccordions(accordions);
  initProgressBar();
  initSpanWrap();
  initScrollAnimation();
  scrollHideLogo();
  moveTopButton();
  initFixed();
  // scrollTopButton();
  changeMediaQuery(mediaQuery);
  function changeMediaQuery(event) {
    if (event.matches) {
      // PC
      scrollHideHeader();
    } else {
      // SP
    }
  }
});

//
// 関数
//

const initDrawer = () => {
  const drawer = document.querySelector(".js-drawer");
  const button = document.querySelector(".js-drawer-button");
  const elements = {
    button,
    drawer,
  };
  new Drawer(elements);

  const initHoverAnimation = () => {
    const navItems = document.querySelectorAll(".js-header-nav-item");
    const imgs = document.querySelectorAll(".js-header-drawer-img");

    const removeImgsClass = () => {
      imgs.forEach((item) => {
        item.classList.remove("is-active");
      });
    };
    const onMouseenter = (index) => {
      const img = imgs[index];
      if (img.classList.contains("is-active")) {
        return;
      }
      removeImgsClass();
      img.classList.add("is-active");
    };

    navItems.forEach((item, index) => {
      const hoverTargets = item.querySelectorAll(".js-header-hover");
      hoverTargets.forEach((target) => {
        target.addEventListener("mouseenter", () => {
          onMouseenter(index);
        });
      });
    });
  };
  initHoverAnimation();
};

const scrollHideLogo = () => {
  ScrollTrigger.create({
    trigger: ".container",
    endTrigger: footer,
    start: "top -100px",
    end: "bottom top",
    onToggle: (self) => {
      if (self.isActive) {
        headerLogo.classList.add("js-outview");
      } else {
        headerLogo.classList.remove("js-outview");
      }
    },
  });
};
const scrollHideHeader = () => {
  if (!footer) {
    // footerが存在しない場合は処理を終了
    return;
  }

  ScrollTrigger.create({
    trigger: footer,
    start: "top 20%",
    onToggle: (self) => {
      if (self.isActive) {
        gsap.to(header, { y: "-100%", duration: 1, ease: "power2.inOut" });
      } else {
        gsap.to(header, { y: "0%", duration: 1, ease: "power2.inOut" });
      }
    },
  });
};

const initFixed = () => {
  if (document.querySelector(".common-fixed") !== null) {
    //online common btn
    const fixedLink = document.querySelector(".common-fixed-link");
    const fixedLinkClose = document.querySelector(".common-fixed-link-close");
    const magazineFixedLinkClose = document.querySelector(
      ".common-fixed-magazine-link__close"
    );
    fixedLinkClose.addEventListener("click", () => {
      fixedLink.classList.add("close");
    });
    ScrollTrigger.create({
      trigger: ".container",
      start: "top -100px",
      endTrigger: footer,
      end: "top bottom",
      onToggle: (self) => {
        if (self.isActive) {
          fixedBanner.classList.remove("is-hidden");
        } else {
          fixedBanner.classList.add("is-hidden");
        }
      },
    });
  }
};

const moveTopButton = () => {
  pageTop.addEventListener("click", () => {
    gsap.to(window, {
      duration: 0.4,
      scrollTo: {
        y: 0,
        autoKill: false,
      },
    });
  });
  ScrollTrigger.create({
    trigger: ".container",
    start: "top -100px",
    onToggle: (self) => {
      if (self.isActive) {
        pageTop.classList.remove("is-hidden");
      } else {
        pageTop.classList.add("is-hidden");
      }
    },
  });
  let pageTopBtn = pageTop.clientHeight * 0.75 + 15 + "px";
  let landingFunc = "top bottom-=" + pageTopBtn;
  ScrollTrigger.create({
    trigger: footer,
    start: landingFunc,
    toggleClass: {
      targets: pageTop,
      className: "is-footer",
    },
  });
};
